import api from '@/api'
import getCurrentUserId from '@/utils/get-current-user-id'

export const enumBounds = {
  incomeRange: 5,
  moneySource: 5,
  maritalStatus: 6,
  investableAssets: 6,
  investableAssetsMinValues: [50000, 100000, 150000, 400000, 750000, 1500000],
  annualSavings: 4,
  monthlyCharges: 5,
  professionnalStatus: 4,
  scp: [1000, 2100, 2200, 2300, 3100, 3200, 3600, 4100, 4600, 4700, 4800, 5100, 5400, 5500, 5600, 6100, 6600, 6900, 7000, 7100, 7200, 7300, 7400, 7500, 7600, 7700]
}

export default {
  create (credentials) {
    return api.post('/users', {user: credentials})
  },

  update (fields) {
    return api.put(`/users/${getCurrentUserId()}/profile`, {profile: fields})
  },

  changePassword (fields) {
    return api.post('/users/me/password', {credentials: fields})
  },

  requestResetPassword (fields) {
    return api.post('/users/password/reset_password', fields)
  },

  updateResetPassword ({token, password, confirmedPassword}) {
    return api.put('/users/password', {user: {
      resetPasswordToken: token,
      password: password,
      passwordConfirmation: confirmedPassword
    }})
  },

  fetch () {
    return api.get('/users/me')
  },

  fetchProfile () {
    return api.get('/users/me/profile')
  },

  fetchQuestions () {
    return api.get('/risk_survey')
  },

  getToken () {
    return api.get('/users/me/connection')
  },

  refreshToken () {
    return api.post('/oauth/token', {grant_type: 'refresh_token', refresh_token: localStorage.getItem('refreshToken')})
  },

  sendToken (token, idUser) {
    return api.post('/users/me/connection', {token, idUser})
  },

  confirm (code) {
    return api.post('/users/confirmations', {token: code})
  },

  resendConfirmation () {
    return api.get('/users/confirmations/new')
  },

  signIn (credentials) {
    return api.post('/oauth/token', {grant_type: 'password', username: credentials.email, password: credentials.password})
  },

  signOut () {
    return api.post('/oauth/revoke', {token: localStorage.getItem('oauthToken')})
  },

  deleteProfile () {
    return api.delete('/users/me')
  },
  confirmDeleteProfile (token) {
    return api.delete(`/users/${token}`)
  },
  testDeletionToken (token) {
    return api.get(`/users/${token}/deletion_validity`)
  },

  fetchPlans () {
    return api.get('/plans')
  },

  verifyCoupon (coupon, planId) {
    return api.post('/coupons/verify', { coupon, planId })
  },

  subscribe (data) {
    return api.post('/users/me/subscriptions', { subscription: data })
  },
  fetchInvitation (invitationToken) {
    return api.get(`/invitations/${invitationToken}`)
  },
  markInvitationAsRead (invitationToken) {
    return api.post(`/invitations/${invitationToken}/mark_as_read`)
  },
  fetchPaymentSources () {
    return api.get('/users/me/payment_sources')
  },
  updatePaymentSource (token) {
    return api.post('/users/me/payment_sources', {
      paymentSource: token
    })
  },
  fetchInvoices () {
    return api.get('/users/me/invoices?limit=100')
  }
}
